import { z } from "zod";

export const BILLING_CATEGORIES = [
	"hourly",
	"flat_rate",
	"pro_bono",
	"administrative",
	"internal",
	"unknown",
] as const;

export const BILLABLE_CATEGORIES = [
	"billable",
	"non_billable",
	"billable_credit",
	"unknown",
] as const;

export const MATTER_POLICY_MODES = ["deny_list", "allow_list"] as const;

export const matterFormSchema = z.object({
	matterId: z.string().trim().min(1, "Matter ID is required").max(255),
	client: z.string().trim().min(1, "Client is required").max(255),
	name: z.string().trim().min(1, "Name is required").max(255),
	description: z.string().trim().min(1, "Description is required"),
	status: z.string().trim().max(255),
	taskGroup: z.string().trim().max(255),
	activityGroup: z.string().trim().max(255),
	billable: z.boolean(),
	visibilityMode: z.enum(MATTER_POLICY_MODES),
	selectabilityMode: z.enum(MATTER_POLICY_MODES),
	billingCategory: z.enum(BILLING_CATEGORIES),
	billableCategory: z.enum(BILLABLE_CATEGORIES),
});

export type MatterFormValues = z.infer<typeof matterFormSchema>;

export const DEFAULT_MATTER_VALUES: MatterFormValues = {
	matterId: "",
	client: "",
	name: "",
	description: "",
	status: "",
	taskGroup: "",
	activityGroup: "",
	billable: true,
	visibilityMode: "deny_list",
	selectabilityMode: "deny_list",
	billingCategory: "unknown",
	billableCategory: "unknown",
};
